import { DateUtils } from './date-utils';

export class TableDataMapper {
  static mapEventReport(events: any[]): any[] {
    return events.map((item: any) => ({
      'Event name': item?.eventName,
      'Event type': item?.eventType,
      school: item?.schoolName?.join(', ') || '',
      // The custom-table 'school' column renders from the _schoolsList array (not the
      // plain `school` string), so expose the API's schoolName list under that key.
      _schoolsList: Array.isArray(item?.schoolName)
        ? item.schoolName.filter((s: any) => !!s)
        : item?.schoolName
          ? [item.schoolName]
          : [],
      date: DateUtils.formatDisplayDate(item?.eventDate),
      region: item?.region,
      status: item?.status === 'Ongoing' ? 'On Today' : item?.status,
    }));
  }

  static mapEventTypeReport(tableData: any[]): any[] {
    return tableData.map((item: any) => ({
      'Event type': item?.eventType,
      'No. of events conducted': item?.numberOfEventsConducted,
      'No. of attendees': item?.numberOfAttendees,
      'Average attendance per event': item?.averageAttendancePerEvent,
    }));
  }
  static mapIndustryPartnerActivity(data: any[]): any[] {
    if (!data?.length) return [];
    return data.map((item) => ({
      'Partner name': item.partnerName ?? '',
      'Total events participated':
        item.totalEventParticipated ?? item.totalEventParticipated ?? 0,
      'Total attendees': item.totalAttendance ?? 0,
      'Event type': item.eventType ?? '',
      'Regions covered': item.regionCovered ?? item.regionCovered ?? '',
    }));
  }

  static mapManagerActivity(tableData: any[]): any[] {
    return tableData.map((item: any) => ({
      'Event manager': item?.eventManager,
      'Total events': item?.totalEvents,
      Completed: item?.completed || 0,
      Upcoming: item?.upcoming || 0,
      'Total attendees': item?.totalAttendees || 0,
      'Average attendance per event': item?.averageAttendancePerEvent || 0,
    }));
  }

  static mapMccPartner(partners: any[]): any[] {
    return partners.map((item: any) => ({
      'partner name': item?.partnerName,
      'Total events participated': item?.totalEventsParticipated,
      'Events types engaged in': item?.eventTypesEngagedIn,
      'Regions covered': item?.regionsCovered,
    }));
  }

  static mapSchoolEngagement(schools: any[]): any[] {
    return schools.map((item: any) => ({
      'School name': item?.schoolName,
      'No. of events participated': item?.totalEventsParticipated,
      'Total students attended': item?.totalStudentsAttended,
      'Total students registered': item?.totalstudentRegister,
      'Most recent event date': DateUtils.formatDisplayDate(
        item?.mostRecentEventDate,
      ),
    }));
  }
  static mapDiversityReport(data: any[]): any[] {
    if (!data || data.length === 0) return [];

    return data.map((item) => ({
      'Diversity category': item.ethnicity || 'Other',
      'No. of events conducted': item.eventCount || 0,
      'No. of attendees': item.count || 0,
      'Average attendance per event':
        item.eventCount > 0
          ? Math.round((item.count || 0) / item.eventCount)
          : 0,
    }));
  }
}
